import { useState, useCallback, useRef } from "react";
import { getSingleOrder } from "../apiService";
import PrintSlip from "../Components/printSlip";
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';

const Reprint = ({ onClose }) => {
    const [number, setNumber] = useState('');
    const [orderPrintData, setOrderPrintData] = useState(null);
    const [printBtnDisable, setIsPrintBtnDisable] = useState(false);
    const componentRef = useRef(null);
    const handleAfterPrint = useCallback(() => {
        console.log("`onAfterPrint` called");
        setIsPrintBtnDisable(false);
        setNumber('');
    }, []);

    const handleBeforePrint = useCallback(() => {
        console.log("`onBeforePrint` called");
        return Promise.resolve();
    }, []);

    const printFn = useReactToPrint({
        contentRef: componentRef,
        documentTitle: "OrderSlip",
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    const handleOnClick = useCallback(() => {
        setTimeout(() => {
            if (componentRef.current) {
                console.log("Attempting to print...");
                printFn();
            } else {
                console.error("PrintSlip is still not available.");
                setIsPrintBtnDisable(false);
            }
        }, 1000); // Give time for the component to mount
    }, [printFn]);
    // Handle input change (only allow numbers and restrict length to 8)
    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        if (value.length <= 8) {
            setNumber(value);
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (number.length !== 8) {
            alert("Please enter exactly 8 digits.");
            return;
        }
        setIsPrintBtnDisable(true);
        try {
            const response = await getSingleOrder(number);
            const data = await response;
            if (response.length > 0) {
                console.log("API Response:", data);
                setOrderPrintData(response);
                toast.success("Reprinting Order.", {
                    position: "top-right",
                    autoClose: 1000,
                });
                handleOnClick();
            } else {
                toast.error("Please Check Order Number.", {
                    position: "top-right",
                    autoClose: 1000,
                });
                setNumber('');
                setIsPrintBtnDisable(false);
            }

        } catch (error) {
            toast.error(error, {
                position: "top-right",
                autoClose: 1000,
            });
            setIsPrintBtnDisable(false);
        }
    };
    const closePopup = () => {
        onClose(false);
    };

    return (
        <div className='.main-container'>
            <div className="popup-overlay">
                <div style={styles.container}>
                    <button className="close-btn" onClick={closePopup}>
                        &times;
                    </button>
                    <h1>Reprint</h1>
                    <form onSubmit={handleSubmit} style={styles.outerdiv}>
                        <input
                            style={styles.inputs}
                            type="text"
                            value={number}
                            onChange={handleChange}
                            maxLength={8}
                            placeholder="Enter 8-digit number"
                        />
                        <div style={styles.buttonContainer}>
                            <button type="submit" disabled={printBtnDisable} style={styles.submitBTN}>Submit</button>
                            <button type="button" onClick={onClose} style={styles.closeButton}>
                                Close
                            </button>
                        </div>
                    </form>
                    <div style={styles.printComp}>
                        {orderPrintData && <PrintSlip orderData={orderPrintData} ref={componentRef} />}
                    </div>
                </div>
            </div>
        </div>
    );
};
const styles = {
    divs: {
        backgroundColor: "#fff",
    },
    outerdiv: {
        backgroundImage: "linear-gradient(90deg, rgba(239, 208, 50, 1) 0%, rgba(255, 86, 86, 1) 50%, rgba(255, 148, 0, 1) 100%)",
    },
    container: {
        textAlign: "center",
        margin: "auto",
        padding: "80px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        width: "80%",
        height: "80%",
        backgroundImage: "linear-gradient(90deg, rgba(239, 208, 50, 1) 0%, rgba(255, 86, 86, 1) 50%, rgba(255, 148, 0, 1) 100%)",
    },
    inputs: {
        width: "60%",
        height: "50px",
        fontSize: "30px",
        backgroundColor: "#fff",
        color: "black",
    },
    buttonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px", // Add space between buttons
        marginTop: "10px",
    },
    submitBTN: {
        backgroundColor: "blue",
        color: "white",
        border: "none",
        padding: "10px 20px",
        cursor: "pointer",
        borderRadius: "3px",
    },
    closeButton: {
        backgroundColor: "red",
        color: "white",
        border: "none",
        padding: "10px 20px",
        cursor: "pointer",
        borderRadius: "3px",
    },
    printComp: {
        display: "none",
    }
};

export default Reprint;
